export default __webpack_public_path__ + "static/media/spot-480.8b9fc272.jpg";